const ChangeScopeTypes = {
  // group change scopes into the lowest level of component they should affect (e.g. module. lesson. item)

  CourseMaterial: {
    COURSE_ELEMENT_LISTING: 'courseElementListing',
    WEEK_MODULE_MAPPING: 'weekModuleMapping',
  } as const,

  Module: {
    MODULE: 'module',
    MODULE_ELEMENT_LISTING: 'moduleElementListing',
  } as const,

  Lesson: {
    LESSON: 'lesson',
    LESSON_ELEMENT_LISTING: 'lessonElementListing',
  } as const,

  Item: {
    ITEM: 'item',
    LOCKS: 'itemLocking',
  } as const,
} as const;

export default ChangeScopeTypes;

export const { CourseMaterial, Module, Lesson, Item } = ChangeScopeTypes;
